// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","601":"d1bfc9e8","701":"aabda8d5","840":"ff5c3116","904":"c3aa3394"}[chunkId] + ".chunk.js";
};